import React from "react"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { Link } from "react-router-dom";
import SEO from '../Components/SEO';
import './Home.css';

// Helper function to assign animations based on slide and layer index
function getAnimationClass(slideId, layerIndex) {
    // Different animation combinations for each slide
    const animations = [
        // Slide 1: Bounce and slide from top
        ['bounce-in-animation', 'slide-animation-top', 'scale-fade-animation', 'fade-blur-animation'],
        // Slide 2: Zoom and slide from left (like truck arriving)
        ['zoom-in-animation', 'slide-animation-left', 'transport-entrance', 'slide-animation-bottom'],
        // Slide 3: Scale fade and slide from right
        ['scale-fade-animation', 'slide-animation-right', 'bounce-in-animation', 'fade-blur-animation'],
        // Slide 4: Rotate and slide from bottom
        ['slide-rotate-animation', 'slide-animation-bottom', 'zoom-in-animation', 'scale-fade-animation'],
        // Slide 5: Transport entrance and bounce
        ['transport-entrance', 'bounce-in-animation', 'slide-animation-top', 'fade-blur-animation'],
        // Slide 6: Zoom and transport entrance
        ['zoom-in-animation', 'transport-entrance', 'slide-animation-left', 'scale-fade-animation'],
        // Slide 7: Bounce and zoom (grand finale)
        ['bounce-in-animation', 'zoom-in-animation', 'transport-entrance', 'fade-blur-animation']
    ];
    
    const slideAnimations = animations[(slideId - 1) % animations.length];
    const animation = slideAnimations[layerIndex % slideAnimations.length];
    const delayClass = layerIndex > 0 ? `animation-delay-${Math.min(layerIndex, 4)}` : '';
    
    return `${animation} ${delayClass}`.trim();
}

function Home() {
    const slides = [
        {
            id: 1,
            videoSrc: `${process.env.PUBLIC_URL}/banner.mp4`,
            videoAlt: "KD General Transport banner video",
            alt: "Excellence in Transportation Nationwide Across UAE",
            layers: [
                { 
                    type: 'text', 
                    content: 'EXCELLENCE IN TRANSPORTATION', 
                    className: 'ms-layer pi-caption01', 
                    style: { 
                        left: '50%', 
                        top: '280px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        fontSize: '64px',
                        fontWeight: '900',
                        color: '#ffffff',
                        textShadow: '3px 3px 6px rgba(0,0,0,0.9)',
                        letterSpacing: '2px'
                    } 
                },
                { 
                    type: 'text', 
                    content: 'NATIONWIDE SERVICES ACROSS UNITED ARAB EMIRATES', 
                    className: 'ms-layer pi-text', 
                    style: { 
                        left: '50%', 
                        top: '370px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        fontSize: '28px',
                        fontWeight: 'bold',
                        color: '#ffffff',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                        letterSpacing: '1px'
                    } 
                },
                { 
                    type: 'text', 
                    content: 'Dubai • Abu Dhabi • Sharjah • Ajman • Ras Al Khaimah • Fujairah • Umm Al Quwain', 
                    className: 'ms-layer pi-text', 
                    style: { 
                        left: '50%', 
                        top: '430px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        fontSize: '18px',
                        color: '#f8f8f8',
                        textShadow: '1px 1px 3px rgba(0,0,0,0.8)',
                        fontWeight: '600'
                    } 
                },
                { 
                    type: 'text', 
                    content: 'The Most Trusted & Professional Transportation Partner in UAE', 
                    className: 'ms-layer pi-text', 
                    style: { 
                        left: '50%', 
                        top: '480px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        fontSize: '16px',
                        color: '#ffd700',
                        fontStyle: 'italic',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.9)',
                        fontWeight: '600'
                    } 
                }
            ]
        },
        {
            id: 2,
            videoSrc: `${process.env.PUBLIC_URL}/banner2.mp4`,
            videoAlt: "KD General Transport banner video 2",
            alt: "Premium Cold Chain Solutions Nationwide",
            layers: [
                { 
                    type: 'text', 
                    content: 'PREMIUM COLD CHAIN SOLUTIONS', 
                    className: 'ms-layer pi-caption01', 
                    style: { 
                        left: '50%', 
                        top: '280px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        fontSize: '58px',
                        fontWeight: '900',
                        color: '#ffffff',
                        textShadow: '3px 3px 6px rgba(0,0,0,0.9)',
                        letterSpacing: '2px'
                    } 
                },
                { 
                    type: 'text', 
                    content: 'Serving Dubai, Abu Dhabi & All Emirates Nationwide', 
                    className: 'ms-layer pi-text', 
                    style: { 
                        left: '50%', 
                        top: '370px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        fontSize: '26px',
                        fontWeight: 'bold',
                        color: '#ffffff',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
                    } 
                },
                { 
                    type: 'text', 
                    content: 'Freezer Vans • Chiller Trucks • Temperature-Controlled Logistics', 
                    className: 'ms-layer pi-text', 
                    style: { 
                        left: '50%', 
                        top: '430px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        fontSize: '18px',
                        color: '#f8f8f8',
                        textShadow: '1px 1px 3px rgba(0,0,0,0.8)',
                        fontWeight: '600'
                    } 
                },
                { 
                    type: 'text', 
                    content: 'Real-Time Monitoring • 24/7 Nationwide Service • Fully Insured Fleet', 
                    className: 'ms-layer pi-text', 
                    style: { 
                        left: '50%', 
                        top: '480px', 
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        fontSize: '16px',
                        color: '#ffd700',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.9)',
                        fontWeight: '600'
                    } 
                }
            ]
        }
    ];

    return (
        <>
            <SEO
                title="Freezer Transportation Dubai | Chiller Transportation Dubai | Mover Transportation Dubai | Trailer Transportation Dubai - #1 in UAE"
                description="KD General Transport LLC - Top Transportation Company in Dubai, UAE. Best Freezer Transportation, Chiller Transportation, Mover Transportation & Trailer Transportation Services in Dubai. Serving Downtown Dubai, JBR, Business Bay, Dubai Marina & All Areas. 24/7 Service. Call +971555592206"
                keywords="freezer transportation Dubai, chiller transportation Dubai, mover transportation Dubai, trailer transportation Dubai, freezer van Dubai, chiller truck Dubai, moving services Dubai, trailer services Dubai, transportation company Dubai, best transport Dubai, freezer transportation UAE, chiller transportation UAE, mover transportation UAE, trailer transportation UAE, cold chain logistics Dubai, temperature controlled transport Dubai, relocation services Dubai, heavy duty trailer Dubai, cotton box trailer Dubai, flat bed trailer Dubai, freezer van services Dubai, chiller truck services Dubai, moving company Dubai, transport services Dubai, logistics Dubai, cargo transport Dubai, freight services Dubai, refrigerated transport Dubai, frozen goods transport Dubai, perishable goods transport Dubai, office relocation Dubai, home moving Dubai, commercial transport Dubai, industrial transport Dubai, transportation near me Dubai, best transportation Dubai, top transport company Dubai, professional transport Dubai, reliable transport Dubai, affordable transport Dubai"
                image="https://kdgeneraltransport.com/img/cars/freezer2.jpeg"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "LocalBusiness",
                    "@id": "https://kdgeneraltransport.com",
                    "name": "KD General Transport LLC",
                    "alternateName": "KD General Transport",
                    "image": [
                        "https://kdgeneraltransport.com/img/logo.png",
                        "https://kdgeneraltransport.com/img/cars/freezer2.jpeg",
                        "https://kdgeneraltransport.com/img/cars/chiller2.jpeg"
                    ],
                    "logo": "https://kdgeneraltransport.com/img/logo.png",
                    "url": "https://kdgeneraltransport.com",
                    "telephone": "+971555592206",
                    "priceRange": "$$",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Oby Property M.B25 Mussafah 15",
                        "addressLocality": "Abu Dhabi",
                        "addressRegion": "Abu Dhabi",
                        "addressCountry": "AE"
                    },
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 24.4539,
                        "longitude": 54.3773
                    },
                    "openingHoursSpecification": [{
                        "@type": "OpeningHoursSpecification",
                        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                        "opens": "00:00",
                        "closes": "23:59"
                    }],
                    "sameAs": ["https://wa.me/971555592206"],
                    "areaServed": [
                        { "@type": "City", "name": "Dubai", "@id": "https://www.wikidata.org/wiki/Q613" },
                        { "@type": "City", "name": "Abu Dhabi", "@id": "https://www.wikidata.org/wiki/Q878" },
                        { "@type": "City", "name": "Sharjah", "@id": "https://www.wikidata.org/wiki/Q18881" },
                        { "@type": "City", "name": "Ajman" },
                        { "@type": "City", "name": "Ras Al Khaimah" },
                        { "@type": "City", "name": "Fujairah" },
                        { "@type": "City", "name": "Umm Al Quwain" }
                    ],
                    "hasOfferCatalog": {
                        "@type": "OfferCatalog",
                        "name": "Transportation Services in Dubai, UAE",
                        "itemListElement": [
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Freezer Transportation Dubai",
                                    "description": "Professional freezer van services for frozen goods transportation in Dubai, UAE. Serving Downtown Dubai, JBR, Business Bay, Dubai Marina and all areas.",
                                    "areaServed": { "@type": "City", "name": "Dubai" },
                                    "serviceType": "Freezer Transportation"
                                }
                            },
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Chiller Transportation Dubai",
                                    "description": "Temperature-controlled chiller truck services for perishable goods in Dubai, UAE. 24/7 service across Dubai and all Emirates.",
                                    "areaServed": { "@type": "City", "name": "Dubai" },
                                    "serviceType": "Chiller Transportation"
                                }
                            },
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Mover Transportation Dubai",
                                    "description": "Professional moving and relocation services in Dubai, UAE. Home moving, office relocation across Dubai, Abu Dhabi, Sharjah and all Emirates.",
                                    "areaServed": { "@type": "City", "name": "Dubai" },
                                    "serviceType": "Moving Services"
                                }
                            },
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Trailer Transportation Dubai",
                                    "description": "Heavy-duty trailer services including cotton box and flat bed trailers in Dubai, UAE. Large-scale cargo transport across Dubai and all UAE.",
                                    "areaServed": { "@type": "City", "name": "Dubai" },
                                    "serviceType": "Trailer Transportation"
                                }
                            }
                        ]
                    },
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "4.9",
                        "reviewCount": "127",
                        "bestRating": "5",
                        "worstRating": "1"
                    }
                }}
            />
<div id="masterslider" className="master-slider ms-skin-default mb-0" style={{ height: '854px', position: 'relative' }}>
    <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        initialSlide={0}
        autoplay={{
            delay: 5000,
            disableOnInteraction: false,
        }}
        navigation={true}
        effect="fade"
        fadeEffect={{
            crossFade: true
        }}
        style={{ height: '100%', width: '100%' }}
    >
        {slides.map((slide) => (
            <SwiperSlide key={slide.id} style={{ position: 'relative', height: '100%' }}>
                <div 
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        ...(slide.bgImage ? {
                            backgroundImage: `url(${slide.bgImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        } : {})
                    }}
                >
                    {slide.videoSrc ? (
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                            preload="auto"
                            aria-label={slide.videoAlt || slide.alt}
                            style={{
                                position: 'absolute',
                                inset: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                zIndex: 1
                            }}
                        >
                            <source src={slide.videoSrc} type="video/mp4" />
                        </video>
                    ) : null}
                    {slide.layers.map((layer, index) => {
                        if (layer.type === 'image') {
                            return (
                                <img
                                    key={index}
                                    src={layer.src}
                                    alt=""
                                    className={`${layer.className} ${layer.animation || ''}`}
                                    style={{
                                        ...layer.style,
                                        position: 'absolute',
                                        zIndex: 2
                                    }}
                                />
                            );
                        } else if (layer.type === 'text') {
                            const Tag = layer.className.includes('pi-caption01') ? 'h2' : 'p';
                            // Determine animation class based on index and slide
                            const animationClass = layer.animation || getAnimationClass(slide.id, index);
                            return (
                                <Tag
                                    key={index}
                                    className={`${layer.className} ${animationClass}`}
                                    style={{
                                        ...layer.style,
                                        position: 'absolute',
                                        zIndex: 2
                                    }}
                                >
                                    {layer.content}
                                </Tag>
                            );
                        }
                        return null;
                    })}
                </div>
            </SwiperSlide>
        ))}
    </Swiper>
</div>
{/* #masterslider end */}
<div className="page-content parallax parallax01 mb-70">
  <div className="container">
    <div className="row services-negative-top">
      <div className="col-md-4 col-sm-4">
        <div className="service-feature-box" style={{ height: '520px', display: 'flex', flexDirection: 'column' }}>
          <div className="service-media">
            <img src={`${process.env.PUBLIC_URL}/img/pics/img01.jpg`} alt="Trucking" />
            <Link to="/services-overview" className="read-more02">
              <span>
                Read more
                <i className="fa fa-chevron-right" />
              </span>
            </Link>
          </div>
          {/* .service-media end */}
          <div className="service-body" style={{ flex: '1 1 auto' }}>
            <div className="custom-heading">
              <h4>FREEZER & CHILLER SERVICES</h4>
            </div>
            {/* .custom-heading end */}
            <p>
              Professional temperature-controlled transportation services across 
              UAE. Our freezer and chiller vans ensure your perishable goods 
              maintain optimal temperature throughout the journey.
            </p>
          </div>
          {/* .service-body end */}
        </div>
        {/* .service-feature-box-end */}
      </div>
      {/* .col-md-4 end */}
      <div className="col-md-4 col-sm-4">
        <div className="service-feature-box" style={{ height: '520px', display: 'flex', flexDirection: 'column' }}>
          <div className="service-media">
            <img src={`${process.env.PUBLIC_URL}/img/cars/mover2.jpeg`} alt="Trucking" />
            <Link to="/mover-1ton-details" className="read-more02">
              <span>
                Read more
                <i className="fa fa-chevron-right" />
              </span>
            </Link>
          </div>
          {/* .service-media end */}
          <div className="service-body" style={{ flex: '1 1 auto' }}>
            <div className="custom-heading">
              <h4>MOVING & RELOCATION</h4>
            </div>
            {/* .custom-heading end */}
            <p>
              Comprehensive moving services across UAE with various truck sizes 
              from 1 ton to 10 ton. Professional handling and secure 
              transportation for your relocation needs.
            </p>
          </div>
          {/* .service-body end */}
        </div>
        {/* .service-feature-box-end */}
      </div>
      {/* .col-md-4 end */}
      <div className="col-md-4 col-sm-4">
        <div className="service-feature-box" style={{ height: '520px', display: 'flex', flexDirection: 'column' }}>
          <div className="service-media">
            <img src={`${process.env.PUBLIC_URL}/img/cars/trailer1.jpeg`} alt="Trucking" />
            <Link to="/cotton-box-details" className="read-more02">
              <span>
                Read more
                <i className="fa fa-chevron-right" />
              </span>
            </Link>
          </div>
          {/* .service-media end */}
          <div className="service-body" style={{ flex: '1 1 auto' }}>
            <div className="custom-heading">
              <h4>TRAILER SERVICES</h4>
            </div>
            {/* .custom-heading end */}
            <p>
              Heavy-duty trailer solutions including cotton box and flat bed 
              trailers for large-scale transportation needs across UAE. Reliable 
              and efficient cargo handling.
            </p>
          </div>
          {/* .service-body end */}
        </div>
        {/* .service-feature-box-end */}
      </div>
      {/* .col-md-4 end */}
    </div>
    {/* .row end */}
    <div className="row">
      <div className="col-md-12">
        <Link
          to="/services-overview"
          className="btn btn-big btn-yellow btn-centered"
        >
          <span>view details</span>
        </Link>
      </div>
      {/* .col-md-12 end */}
    </div>
    {/* .row end */}
  </div>
  {/* .container end */}
</div>




<div className="page-content">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="custom-heading02">
          <h2>What we Offer</h2>
          <p>TAILORED LOGISTIC SERVICES</p>
        </div>
        {/* .custom-heading02 end */}
      </div>
      {/* .col-md-12 end */}
    </div>
    {/* .row end */}
    <div className="row mb-30">
      <div className="col-md-6 col-sm-6">
        <div className="service-icon-left-boxed">
          <div
            className="icon-container animated triggerAnimation zoomIn"
            data-animate="zoomIn"
            style={{ opacity: 1 }}
          >
            <img src={`${process.env.PUBLIC_URL}/img/svg/pi-food-beverage.svg`} alt="freezer van icon" />
          </div>
          {/* .icon-container end */}
          <div className="service-details">
            <h3>Freezer Van Services</h3>
            <p>
              Professional freezer van transportation services across UAE. Our 
              fleet includes 3 ton, 7 ton, 10 ton trucks and trailers, all 
              equipped with advanced temperature control systems for frozen goods.
            </p>
          </div>
          {/* .service-details end */}
        </div>
        {/* .service-icon-left-boxed end */}
      </div>
      {/* .col-md-6 end */}
      <div className="col-md-6 col-sm-6">
        <div className="service-icon-left-boxed">
          <div
            className="icon-container animated triggerAnimation zoomIn"
            data-animate="zoomIn"
            style={{ opacity: 1 }}
          >
            <img src={`${process.env.PUBLIC_URL}/img/svg/pi-cargo-box-2.svg`} alt="chiller truck icon" />
          </div>
          {/* .icon-container end */}
          <div className="service-details">
            <h3>Chiller Truck Services</h3>
            <p>
              Reliable chiller van services for temperature-sensitive goods 
              across UAE. Available in multiple sizes (3 ton, 7 ton, 10 ton) 
              with state-of-the-art refrigeration systems to maintain optimal 
              conditions.
            </p>
          </div>
          {/* .service-details end */}
        </div>
        {/* .service-icon-left-boxed end */}
      </div>
      {/* .col-md-6 end */}
    </div>
    {/* .row.mb-30 end */}
    <div className="row">
      <div className="col-md-6 col-sm-6">
        <div className="service-icon-left-boxed">
          <div
            className="icon-container animated triggerAnimation zoomIn"
            data-animate="zoomIn"
            style={{ opacity: 1 }}
          >
            <img src={`${process.env.PUBLIC_URL}/img/svg/pi-forklift-truck-5.svg`} alt="moving truck icon" />
          </div>
          {/* .icon-container end */}
          <div className="service-details">
            <h3>Moving Services</h3>
            <p>
              Professional moving and relocation services across UAE. Our fleet 
              includes 1 ton, 1.5 ton, 3 ton, and 10 ton trucks to accommodate 
              any moving requirement, from small apartments to large commercial 
              relocations.
            </p>
          </div>
          {/* .service-details end */}
        </div>
        {/* .service-icon-left-boxed end */}
      </div>
      {/* .col-md-6 end */}
      <div className="col-md-6 col-sm-6">
        <div className="service-icon-left-boxed">
          <div
            className="icon-container animated triggerAnimation zoomIn"
            data-animate="zoomIn"
            style={{ opacity: 1 }}
          >
            <img src={`${process.env.PUBLIC_URL}/img/svg/pi-truck-8.svg`} alt="trailer truck icon" />
          </div>
          {/* .icon-container end */}
          <div className="service-details">
            <h3>Trailer Transportation</h3>
            <p>
              Heavy-duty trailer services including cotton box and flat bed 
              trailers for large-scale cargo transportation. Ideal for 
              construction materials, machinery, and bulk goods across UAE.
            </p>
          </div>
          {/* .service-details end */}
        </div>
        {/* .service-icon-left-boxed end */}
      </div>
      {/* .col-md-6 end */}
    </div>
    {/* .row.mb-30 end */}
  </div>
  {/* .container end */}
</div>




<div className="page-content custom-bkg bkg-dark-blue column-img-bkg dark mb-70">
  <div className="container-fluid">
    <div className="row">
      <div className="col-md-4 col-md-offset-2 custom-col-padding-both">
        <div className="custom-heading">
          <h3>INDUSTRY SECTORS COVERAGE</h3>
        </div>
        {/* .custom-heading end */}
        <p>
          We cover different industry sectors, from food and beverage, chemical,
          retail, durable goods and more. Check the full list.
        </p>
        <ul className="service-list clearfix">
          <li>
            <div className="icon-container">
              <img
                className="svg-white"
                src={`${process.env.PUBLIC_URL}/img/svg/pi-cargo-box-2.svg`}
                alt="icon"
              />
            </div>
            {/* .icon-container end */}
            <p>Consumer Packaged Goods</p>
          </li>
          <li>
            <div className="icon-container">
              <img
                className="svg-white"
                src={`${process.env.PUBLIC_URL}/img/svg/pi-mark-energy.svg`}
                alt="icon"
              />
            </div>
            {/* .icon-container end */}
            <p>Chemical Goods</p>
          </li>
          <li>
            <div className="icon-container">
              <img
                className="svg-white"
                src={`${process.env.PUBLIC_URL}/img/svg/pi-food-beverage.svg`}
                alt="icon"
              />
            </div>
            {/* .icon-container end */}
            <p>Food and Beverage</p>
          </li>
          <li>
            <div className="icon-container">
              <img
                className="svg-white"
                src={`${process.env.PUBLIC_URL}/img/svg/pi-cargo-retail.svg`}
                alt="icon"
              />
            </div>
            {/* .icon-container end */}
            <p>Retail Goods</p>
          </li>
          <li>
            <div className="icon-container">
              <img
                className="svg-white"
                src={`${process.env.PUBLIC_URL}/img/svg/pi-truck-8.svg`}
                alt="icon"
              />
            </div>
            {/* .icon-container end */}
            <p>Trailer services</p>
          </li>
        </ul>
        {/* .service-list end */}
      </div>
      {/* .col-md-6 end */}
      <div className="col-md-6 img-bkg01" style={{ height: 750 }}>
        <div>&nbsp;</div>
      </div>
    </div>
    {/* .row end */}
  </div>
  {/* .container end */}
</div>



<div className="page-content">
  <div className="container">
    <div className="row">
      <div className="col-md-4 col-sm-6">
        <div className="custom-heading">
          <h3>Why Choose Us</h3>
        </div>
        {/* .custom-heading end */}
        <ul className="pi-latest-posts clearfix">
          <li>
            <div className="post-media">
              <img src={`${process.env.PUBLIC_URL}/img/cars/freezer2.jpeg`} alt="Professional Fleet" />
            </div>
            {/* .post-media end */}
            <div className="post-details">
              <div className="post-date">
                <p>
                  <i className="fa fa-truck" />
                  Modern Fleet
                </p>
              </div>
              <Link to="/services-overview">
                <h4>Professional Fleet Across UAE</h4>
              </Link>
              <p style={{ marginTop: '10px', fontSize: '14px', lineHeight: '1.6' }}>
                Our modern fleet includes specialized vehicles for freezer, chiller, moving, and trailer services. All vehicles are regularly maintained and fully insured.
              </p>
              <Link to="/services-overview" className="read-more">
                <span>
                  View Services
                  <i className="fa fa-chevron-right" />
                </span>
              </Link>
            </div>
            {/* .post-details end */}
          </li>
          <li>
            <div className="post-media">
              <img src={`${process.env.PUBLIC_URL}/img/cars/chiller2.jpeg`} alt="Temperature Control" />
            </div>
            {/* .post-media end */}
            <div className="post-details">
              <div className="post-date">
                <p>
                  <i className="fa fa-thermometer-half" />
                  Temperature Control
                </p>
              </div>
              <Link to="/chiller-ven">
                <h4>Advanced Temperature Control Systems</h4>
              </Link>
              <p style={{ marginTop: '10px', fontSize: '14px', lineHeight: '1.6' }}>
                State-of-the-art refrigeration systems with real-time monitoring. Perfect for food, pharmaceuticals, and perishable goods across all Emirates.
              </p>
              <Link to="/chiller-ven" className="read-more">
                <span>
                  Learn More
                  <i className="fa fa-chevron-right" />
                </span>
              </Link>
            </div>
            {/* .post-details end */}
          </li>
        </ul>
        {/* .pi-latest-posts end */}
      </div>
      {/* .col-md-4 end */}
      <div className="col-md-4 col-sm-6">
        <div className="custom-heading">
          <h3>what clients say</h3>
        </div>
        {/* .custom-heading end */}
        <div className="carousel-container">
          <div
            id="testimonial-carousel"
            className="owl-carousel owl-carousel-navigation owl-theme owl-loaded owl-responsive-1000"
          >
            {/* .owl-item end */}
            {/* .owl-item end */}
            {/* .owl-item end */}
            <div className="owl-stage-outer owl-height" style={{ height: 222 }}>
              <div
                className="owl-stage"
                style={{
                  transform: "translate3d(-1950px, 0px, 0px)",
                  transition: "0.25s",
                  width: 2730
                }}
              >
                <div
                  className="owl-item cloned"
                  style={{ width: 360, marginRight: 30 }}
                >
                  <div className="owl-item">
                    <div className="testimonial">
                      <p>
                        KD General Transport has been our trusted partner for freezer van services across Dubai. Their temperature control is excellent, and our frozen goods always arrive in perfect condition. Highly professional team!
                      </p>
                      <div className="testimonial-author">
                        <p>
                          AHMED AL MANSURI, <br />
                          Food Distribution Company, Dubai
                        </p>
                      </div>
                      {/* .testimonial-author end */}
                    </div>
                    {/* .testimonial end */}
                  </div>
                </div>
                <div
                  className="owl-item cloned"
                  style={{ width: 360, marginRight: 30 }}
                >
                  <div className="owl-item">
                    <div className="testimonial">
                      <p>
                        We've used KD General Transport for multiple office relocations in Abu Dhabi. Their moving services are reliable, efficient, and the team handles everything with care. Great value for money and excellent customer service.
                      </p>
                      <div className="testimonial-author">
                        <p>
                          SARAH JOHNSON, <br />
                          Business Owner, Abu Dhabi
                        </p>
                      </div>
                      {/* .testimonial-author end */}
                    </div>
                    {/* .testimonial end */}
                  </div>
                </div>
                <div
                  className="owl-item"
                  style={{ width: 360, marginRight: 30 }}
                >
                  <div className="owl-item">
                    <div className="testimonial">
                      <p>
                        Outstanding chiller truck service! KD General Transport maintains perfect temperature control for our pharmaceutical deliveries. Their real-time monitoring gives us complete confidence. Highly recommended for cold chain logistics.
                      </p>
                      <div className="testimonial-author">
                        <p>
                          DR. MOHAMMED HASSAN, <br />
                          Medical Supply Company, Sharjah
                        </p>
                      </div>
                      {/* .testimonial-author end */}
                    </div>
                    {/* .testimonial end */}
                  </div>
                </div>
                <div
                  className="owl-item"
                  style={{ width: 360, marginRight: 30 }}
                >
                  <div className="owl-item">
                    <div className="testimonial">
                      <p>
                        Best transportation service in UAE! We've used their trailer services for construction materials across multiple Emirates. Always on time, professional drivers, and competitive pricing. KD General Transport is our go-to partner.
                      </p>
                      <div className="testimonial-author">
                        <p>
                          KHALID AL ZAABI, <br />
                          Construction Company, Ras Al Khaimah
                        </p>
                      </div>
                      {/* .testimonial-author end */}
                    </div>
                    {/* .testimonial end */}
                  </div>
                </div>
                <div
                  className="owl-item"
                  style={{ width: 360, marginRight: 30 }}
                >
                  <div className="owl-item">
                    <div className="testimonial">
                      <p>
                        Professional, reliable, and affordable. KD General Transport helped us move our entire warehouse from Dubai to Ajman. Their 10-ton trucks handled everything perfectly. Excellent communication throughout the process.
                      </p>
                      <div className="testimonial-author">
                        <p>
                          FATIMA ALI, <br />
                          Retail Business Owner, Ajman
                        </p>
                      </div>
                      {/* .testimonial-author end */}
                    </div>
                    {/* .testimonial end */}
                  </div>
                </div>
                <div
                  className="owl-item cloned active"
                  style={{ width: 360, marginRight: 30 }}
                >
                  <div className="owl-item">
                    <div className="testimonial">
                      <p>
                        KD General Transport has been our trusted partner for freezer van services across Dubai. Their temperature control is excellent, and our frozen goods always arrive in perfect condition. Highly professional team!
                      </p>
                      <div className="testimonial-author">
                        <p>
                          AHMED AL MANSURI, <br />
                          Food Distribution Company, Dubai
                        </p>
                      </div>
                      {/* .testimonial-author end */}
                    </div>
                    {/* .testimonial end */}
                  </div>
                </div>
                <div
                  className="owl-item cloned"
                  style={{ width: 360, marginRight: 30 }}
                >
                  <div className="owl-item">
                    <div className="testimonial">
                      <p>
                        We've used KD General Transport for multiple office relocations in Abu Dhabi. Their moving services are reliable, efficient, and the team handles everything with care. Great value for money and excellent customer service.
                      </p>
                      <div className="testimonial-author">
                        <p>
                          SARAH JOHNSON, <br />
                          Business Owner, Abu Dhabi
                        </p>
                      </div>
                      {/* .testimonial-author end */}
                    </div>
                    {/* .testimonial end */}
                  </div>
                </div>
              </div>
            </div>
            <div className="owl-controls">
              <div className="owl-nav">
                <div className="owl-prev" style={{}}>
                  prev
                </div>
                <div className="owl-next" style={{}}>
                  next
                </div>
              </div>
              <div className="owl-dots" style={{ display: "none" }} />
            </div>
          </div>
          {/* #testimonial-carousel end */}
        </div>
        {/* .carousel-container end */}
      </div>
      {/* .col-md-4 end */}
      <div className="col-md-4 col-sm-12 clearfix">
        <div className="custom-heading">
          <h3>our locations</h3>
        </div>
        {/* .custom-heading end */}
        <img src={`${process.env.PUBLIC_URL}/img/pics/locations.jpg`} alt="UAE Locations" />
        <br />
        <p>
          KD General Transport provides comprehensive transportation services across all seven Emirates of the UAE. We serve businesses and individuals in Dubai, Abu Dhabi, Sharjah, Ajman, Umm Al Quwain, Ras Al Khaimah, and Fujairah with reliable and professional service.
        </p>
        <Link to="/contact" className="read-more">
          <span>
            Contact Us
            <i className="fa fa-chevron-right" />
          </span>
        </Link>
      </div>
      {/* .col-md-4 end */}
    </div>
    {/* .row end */}
  </div>
  {/* .container end */}
</div>


 


        </>
    )
}

export default Home


